import { render, staticRenderFns } from "./AccrualBasis.vue?vue&type=template&id=4071a55e&scoped=true&"
import script from "./AccrualBasis.vue?vue&type=script&lang=js&"
export * from "./AccrualBasis.vue?vue&type=script&lang=js&"
import style0 from "./AccrualBasis.vue?vue&type=style&index=0&id=4071a55e&scoped=true&lang=less&"
import style1 from "./AccrualBasis.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071a55e",
  null
  
)

export default component.exports